(function () {
    "use strict";

    angular.module("app").controller("OrganisationScreeningController", OrganisationScreeningController);
    OrganisationScreeningController.$inject = [
        "$rootScope", "$scope", "$timeout", "$window",
        "organisationService", "screeningService",
        "FvmScreeningRemarkValidator", "user", "OrganisationRemarkValidator",
        "enumService", "controllerDecorator"
    ];
    function OrganisationScreeningController($rootScope, $scope, $timeout, $window,
        organisationService, screeningService,
        FvmScreeningRemarkValidator, user, OrganisationRemarkValidator,
        enumService, controllerDecorator) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["files", "dialog", "comments", "navigation"]);

        const justificationSections = ['122', '121'];
        const personSections = ['170', '171'];

        $scope.isReadOnly = isReadOnly;
        function isReadOnly() {
            if (!$scope.request || $scope.request.Screenings === undefined || $scope.screening === undefined)
                return true;

            const states = [enumService.ScreeningStatusCode.Completed, enumService.ScreeningStatusCode.Stopped, enumService.ScreeningStatusCode.ReadOnly];

            const screeningStatusCode = parseInt($scope.screening.Status);
            return states.includes(screeningStatusCode);
        }

        $scope.request = null;

        function initialize() {
            // Parse data from URL
            const requestParameters = new URLSearchParams($window.location.search);
            $scope.requestId = requestParameters.get('screeningId');
            $scope.isEdit = requestParameters.get('edit');

            RegisterBroadcastListeners();
        }

        initialize();

        /**
         * Takes the request returned from an API call and massages the data
         * @param {Object} data 
         */
        function initialLinkData(res) {
            $scope.request = res.FVM;
            $scope.screening = res.Screening;

            vm.Comments.Initialize({ RequestId: $scope.request.PublicId, DossierId: null, OrganisationId: res.FVM.DossierPublicId, ICD: $scope.screening.DoneBy });

            processFvm();
        }

        function shouldShowButtonAcceptInActionBar() {
            return parseInt($scope.request.Status) !== enumService.FvmStatusCodes.ConfirmationGivenToStopScreening
                && parseInt($scope.screening.Status) === enumService.ScreeningStatusCode.New;
        }

        function shouldShowButtonAddResultInActionBar() {
            return parseInt($scope.request.Status) !== enumService.FvmStatusCodes.ConfirmationGivenToStopScreening
                && parseInt($scope.screening.Status) === enumService.ScreeningStatusCode.Accepted;
        }

        /**
         * Handles the logic related to company branches
         */
        function processFvm() {
            $rootScope.$broadcast('request_buttonVisibilityChange', shouldShowButtonAcceptInActionBar(), shouldShowButtonAddResultInActionBar());
        }

        $scope.ProcessScreeningRemarks = (screeningRemarks) => {
            if (!screeningRemarks || !$scope.request) return;

            setButtonStates();
        };

        $scope.ShouldSetRemarkReadOnly = (screeningRemark) => {
            return screeningRemark && screeningRemark.ScreeningPublicId !== $scope.screening.PublicId;
        };

        function start() {
            vm.SetLoadingState(true);

            const loader = $scope.isEdit ? vm.Api.GetFvmEditByScreeningId : vm.Api.GetFvmByScreeningId;

            loader(
                { ScreeningId: $scope.requestId },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }
                    initialLinkData(result.data);

                    vm.Api.GetFvmPhase1SignaturesByUser({ FvmId: $scope.request.PublicId }, (r) => $scope.Signatures = r.data);

                    vm.Api.GetAllScreeningRemarksByFvm(
                        { PublicId: $scope.request.PublicId },
                        (r) => {
                            if (!CheckResultReceived(r)) {
                                vm.ShowError(r);
                                return;
                            }

                            $scope.ScreeningRemarks = r.data;
                            $scope.ProcessScreeningRemarks(r.data);

                            showAllToggles();
                        },
                        vm.ShowError
                    );
                },
                vm.ShowError,
                () => {
                    setButtonStates();

                    vm.SetLoadingState(false);
                }
            );
        }

        function showAllToggles() {
            $('div[data-toggle="collapse"]').each(function () {
                const objectID = $(this).attr('href');
                $(objectID).collapse('show');
            });
        }

        function setRetourResult() {
            vm.SetLoadingState(true);

            $scope.screening.ResultCode = '20';

            screeningService.saveScreening($scope.screening,
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    vm.Navigator.ReturnToPreviousPage();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false));
        }

        $scope.isCurrent = (tab) => organisationService.currentTab === tab;

        function RegisterBroadcastListeners() {
            $scope.$on('navigation_change', (_, tab) => organisationService.currentTab = tab.key);
            $scope.$on('actionBar_acceptedClick', () => setAsAccepted());
            $scope.$on('actionBar_extractClick', () => downloadExtract());
            $scope.$on('actionBar_returnClick', () => setRetourResult());
            $scope.$on('actionBar_closeClick', () => vm.Navigator.ReturnToPreviousPage());
            $scope.$on('actionBar_addResultClick', addResult);
        }

        function addResult() {
            if ($scope.screening.ResultCode === '0')
                $scope.screening.ResultCode = null;

            $scope.codeScreeningResultsCOL = screeningService.getPossibleScreeningResults($scope.screening);

            $scope.handleAddScreeningResultSuccess = function handleAddScreeningResultSuccess() {
                vm.ShowSuccess($scope.translations.Actionbar_YourChangesHaveBeenSavedSuccessfully);
                vm.Navigator.ReturnToPreviousPage();
            };

            const options = {
                onEscape: true,
                scope: $scope,
                size: 'large',
                title: $scope.translations.Screening_AddResult_Detail,
                templateHtml: `<habil-screening-answer screening="screening" is-foreign="screening.IsForeign" is-in-modal="true" on-reload="handleAddScreeningResultSuccess"></habil-screening-answer>`
            };

            vm.Dialog.Custom(options);
        }

        function downloadExtract() {
            vm.SetLoadingState(true);

            vm.Api.GetPhaseFile(`id=${$scope.requestId}`)
                .then(vm.File.Save)
                .catch(vm.ShowError)
                .finally(() => vm.SetLoadingState(false));
        }

        $scope.$watch(setButtonStates());

        function remarkFilterFactory(sections) {
            return function (remark) {
                return sections.includes(remark.Section);
            };
        }

        $scope.filterRemarkFunctionIdentity = remarkFilterFactory(['110']);
        $scope.filterRemarkFunctionJustification = remarkFilterFactory(['120']);

        $scope.filterPersonInvalidated = remarkFilterFactory(['140']);

        $scope.DoesItemContainSectionRemark = (item, section) => item.Remarks.some(remark => remark.Section === section);

        $scope.PersonShouldBeOpened = personShouldBeOpened;
        function personShouldBeOpened(person) {
            if (!person || !person.IVMLink)
                return false;

            return !$scope.DoesItemContainSectionRemark(person, personSections[0]);
        };

        $scope.justificationShouldBeOpened = (justification) => {
            if (!justification) return;
            return !$scope.DoesItemContainSectionRemark(justification, justificationSections[0]);
        };

        function setAsAccepted() {
            vm.SetLoadingState(true);

            screeningService.setAsAccepted($scope.requestId,
                () => {
                    vm.Navigator.ReturnToPreviousPage();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false));
        }

        start();

        /**
         * Updates the Accept and Retour buttons in the action bar.
         */
        function setButtonStates() {
            if (isReadOnly()) {
                $rootScope.$broadcast('request_stateCanReturn', false);
                $rootScope.$broadcast('request_stateChangedTo', false);
                return;
            }

            // Initially begin with false
            let isAllowed = false;
            let canReturn = false;
            let canAccept = false;

            const hasInvalid = FvmScreeningRemarkValidator.OrganisationHasInvalidRemarks($scope.ScreeningRemarks, user.WorksForPartner);
            const hasIndeterminate = FvmScreeningRemarkValidator.OrganisationHasIndeterminateRemarks($scope.ScreeningRemarks, user.WorksForPartner);

            canReturn = hasInvalid && !hasIndeterminate && !FvmScreeningRemarkValidator.OrganisationHasInvalidRemarksWithoutReason($scope.ScreeningRemarks, user.WorksForPartner);
            canAccept = !hasInvalid && !hasIndeterminate;
            isAllowed = true;

            // Notify the action bar of a change in state
            $rootScope.$broadcast('request_stateChangedTo', isAllowed);
            $rootScope.$broadcast('request_stateCanReturn', canReturn);
            $rootScope.$broadcast('request_stateCanAccept', canAccept);
        }

        $scope.IsTabInvalidated = function (key) {
            return FvmScreeningRemarkValidator.OrganisationHasIndeterminateRemarks($scope.ScreeningRemarks, key, user.WorksForPartner)
                || FvmScreeningRemarkValidator.OrganisationHasInvalidRemarksWithoutReason($scope.ScreeningRemarks, key, user.WorksForPartner);
        };

        function getEmbeddedTranslation(object, key) {
            const translation = object[key + vm.Settings.locale.toUpperCase()];

            return translation ? translation : object[key + "EN"];
        }

        $scope.GetPersonActionDescription = getPersonActionDescription;
        function getPersonActionDescription(person) {
            if (!person)
                return;

            const actionDescriptions = [];

            if (person.StatusCode === enumService.PersonStatusCodes.UserBlock) {
                actionDescriptions.push(vm.getTranslation("Person_Remark_Remove"));

                return actionDescriptions.join(' / ');
            }

            if (person.Action) {
                const actionDescription = getEmbeddedTranslation(person.Action, "Description");

                if (person.Action.Code === enumService.PersonActionCodes.StartIVM) {
                    const statusCode = $rootScope.codeStatusRequestsIVMFromFVM.find(o => o.Key == person.IVMStatus);
                    if (statusCode) {
                        actionDescriptions.push(`${actionDescription} [${statusCode.Value}]`);

                        if (getNoAcknowledgmentChosenFor(person).length > 0) {
                            if (!person.IsInvitedToSignNoAcknowledgementDocument) {
                                actionDescriptions.push(vm.getTranslation("NoAcknowledgment_Title"));
                            }
                            else {
                                if (!person.HasSendNoAcknowledgeDocument) {
                                    actionDescriptions.push(vm.getTranslation("NoAcknowledgementInvitationWasSent"));
                                }
                                else {
                                    actionDescriptions.push(vm.getTranslation("NoAcknowledgementWasSigned"));
                                }
                            }
                        }
                    }
                    else {
                        actionDescriptions.push(actionDescription);
                    }
                } else if (person.Action.Code === enumService.PersonActionCodes.NoAcknowledgement) {
                    if (person.IsInvitedToSignNoAcknowledgementDocument) {
                        if (!person.HasSendNoAcknowledgeDocument) {
                            actionDescriptions.push(vm.getTranslation("NoAcknowledgementInvitationWasSent"));
                        } else {
                            actionDescriptions.push(vm.getTranslation("NoAcknowledgementWasSigned"));
                        }
                    }
                    else {
                        actionDescriptions.push(actionDescription);
                    }
                }
                else {
                    // Action required
                    actionDescriptions.push(actionDescription);
                }
            }

            return actionDescriptions.join(' / ');
        }

        function getNoAcknowledgmentChosenFor(person) {
            if (!person || !person.NoAcknowledgementForClearanceCodes)
                return [];

            return JSON.parse(person.NoAcknowledgementForClearanceCodes);
        }

        /**
         * Called by ng-init to open invalidated justifications on load
         * @param {Object} justification The justification model
         * @param {Number} index The index of the justification in the request
         */
        $scope.InitializeJustificationState = function (justification, index) {
            // We NEED to use timeout to wait until after the justification is rendered
            // Without timeout we need to use ng-class to conditionally apply the in class
            // This causes issues when adding new items
            $timeout(() => setJustificationState(justification, index), 0);
        };

        //#endregion

        $scope.JustificationNeedsToBeValidated = justificationNeedsToBeValidated;
        function justificationNeedsToBeValidated(justification) {
            return !(justification.IsCopied && justification.Action === null);
        }

        function setJustificationState(justification, index) {
            if (!justificationNeedsToBeValidated(justification))
                return;

            const target = $(`#justification-${index}`);
            if (!OrganisationRemarkValidator.IsItemChecked(justification, 'justification'))
                target.collapse('show');
            else
                target.collapse('hide');
        }

        $scope.saveIdentityRemark = vm.Api.CreateUpdateScreeningFVMRemarkIdentity;
        $scope.saveActivityRemark = vm.Api.CreateUpdateScreeningFVMRemarkActivity;
        $scope.saveJustificationRemark = vm.Api.CreateUpdateScreeningFVMRemarkJustification;
        $scope.savePersonRemark = vm.Api.CreateUpdateScreeningFVMRemarkPerson;
        $scope.saveRelationsRemark = vm.Api.CreateUpdateScreeningFVMRemarkRelations;
    }
})();